import _ from 'lodash'
export class SearchDataModel {
  id = null
  name = ''
  parameter = {
    age: { minimum: 18, maximum: 65 },
    gender: null,
    address: {
      prefectures: [],
      cities: [],
      /* 選択オプション
      * (空文字)： 現住所か希望勤務地いずれか合致
      * present_address : 現住所のみ
      * desired_work_place : 希望勤務地のみ
      */
      selectedOption: '',
      containNonHopeUser: false
    },
    educationalBackground: null,
    graduatedSchool: {
      year: { from: null, to: null },
      deptCodes: [],
      keywords: [],
      operator: 'and'
    },
    changeOverJobsCount: { maximum: null },
    employed: null,
    annualSalary: { minimum: null, maximum: null },
    occupations: {
      experienced: [],
      desired: [],
      containNonHopeUser: false,
      operator: 'or'
    },
    businesses: {
      experienced: [],
      desired: [],
      containNonHopeUser: false,
      operator: 'or'
    },
    skills: { conditions: [], operator: 'and' },
    licenses: { ids: [], operator: 'and' },
    isReviewSaved: false,
    activeRecent: null,
    hasCareerResumes: false,
    toeicScore: { minimum: null },
    toeflScore: { minimum: null },
    languageSkills: [],
    freeWord: { keywords: [], operator: 'and' },
    excludeWord: { keywords: [], operator: 'or' },
    workStyles: { conditions: [], operator: 'and' },
    employmentTypes: [],
    desiredEmploymentTypes: [],
    married: null,
    hasChild: null,
    canHomeMoving: null,
    registrationDate: {
      selectedDateTimeWithinDays: null,
      selectedDateTimeRangeForm: null
    },
    resumeUpdateDate: {
      selectedDateTimeWithinDays: null,
      selectedDateTimeRangeForm: null
    },
    activeDate: {
      from: '',
      to: ''
    },
    excludedApproachedScout: {
      otherCompany: {
        maximum: null
      },
      ownCompany: {
        thisJob: {
          selectedDateTimeWithinDays: null,
          selectedDateTimeRangeForm: null
        },
        otherJob: {
          selectedDateTimeWithinDays: null,
          selectedDateTimeRangeForm: null
        }
      }
    },
    excludedCandidateOtherJob: false,
    excludeEntryOtherCompanyJob: false,
    userId: null
  }

  condition = {
    graduatedSchoolKeyword: '',
    freeWord: '',
    excludeWord: '',
    selectedRegistrationDateValue: {},
    registrationDate_from: '',
    registrationDate_to: '',
    selectedResumeUpdateDateValue: {},
    resumeUpdateDate_from: '',
    resumeUpdateDate_to: '',
    selectedApproachedThisJobOptionValue: {},
    approachedThisJob_from: '',
    approachedThisJob_to: '',
    selectedApproachedOtherJobOptionValue: {},
    approachedOtherJob_from: '',
    approachedOtherJob_to: ''
  }

  constructor (searchData) {
    if (searchData) {
      this.id = _.get(searchData, 'id', null)
      this.name = _.toString(_.get(searchData, 'name'))
      const parameter = searchData.parameter
      this.parameter.age.minimum = _.get(parameter, 'age.minimum', 18)
      this.parameter.age.maximum = _.get(parameter, 'age.maximum', 65)
      this.parameter.gender = _.get(parameter, 'gender', null)
      this.parameter.address.prefectures = _.toArray(_.get(parameter, 'address.prefectures'))
      this.parameter.address.cities = _.toArray(_.get(parameter, 'address.cities'))
      this.parameter.address.selectedOption = _.get(parameter, 'address.selectedOption', '')
      this.parameter.address.containNonHopeUser = !!_.get(parameter, 'address.containNonHopeUser')
      this.parameter.educationalBackground = _.get(parameter, 'educationalBackground', null)
      this.parameter.graduatedSchool.year.from = _.get(parameter, 'graduatedSchool.year.from', null)
      this.parameter.graduatedSchool.year.to = _.get(parameter, 'graduatedSchool.year.to', null)
      this.parameter.graduatedSchool.deptCodes = _.toArray(_.get(parameter, 'graduatedSchool.deptCodes'))
      this.parameter.graduatedSchool.keywords = _.toArray(_.get(parameter, 'graduatedSchool.keywords'))
      this.parameter.graduatedSchool.operator = _.toString(_.get(parameter, 'graduatedSchool.operator', 'and'))
      this.parameter.changeOverJobsCount.maximum = _.get(parameter, 'changeOverJobsCount.maximum', null)
      this.parameter.employed = _.get(parameter, 'employed', null)
      this.parameter.annualSalary.minimum = _.get(parameter, 'annualSalary.minimum', null)
      this.parameter.annualSalary.maximum = _.get(parameter, 'annualSalary.maximum', null)
      this.parameter.occupations.experienced = _.toArray(_.get(parameter, 'occupations.experienced'))
      this.parameter.occupations.desired = _.toArray(_.get(parameter, 'occupations.desired'))
      this.parameter.occupations.containNonHopeUser = !!_.get(parameter, 'occupations.containNonHopeUser')
      this.parameter.occupations.operator = _.get(parameter, 'occupations.operator', 'or')
      this.parameter.businesses.experienced = _.toArray(_.get(parameter, 'businesses.experienced'))
      this.parameter.businesses.desired = _.toArray(_.get(parameter, 'businesses.desired'))
      this.parameter.businesses.containNonHopeUser = !!_.get(parameter, 'businesses.containNonHopeUser')
      this.parameter.businesses.operator = _.get(parameter, 'businesses.operator', 'or')
      this.parameter.skills.conditions = _.toArray(_.get(parameter, 'skills.conditions'))
      this.parameter.skills.operator = _.toString(_.get(parameter, 'skills.operator', 'and'))
      this.parameter.licenses.ids = _.toArray(_.get(parameter, 'licenses.ids'))
      this.parameter.licenses.operator = _.toString(_.get(parameter, 'licenses.operator', 'and'))
      this.parameter.isReviewSaved = !!_.get(parameter, 'isReviewSaved')
      this.parameter.activeRecent = _.get(parameter, 'activeRecent', null)
      this.parameter.hasCareerResumes = !!_.get(parameter, 'hasCareerResumes')
      this.parameter.toeicScore.minimum = _.get(parameter, 'toeicScore.minimum', null)
      this.parameter.toeflScore.minimum = _.get(parameter, 'toeflScore.minimum', null)
      this.parameter.languageSkills = _.toArray(_.get(parameter, 'languageSkills'))
      this.parameter.freeWord.keywords = _.toArray(_.get(parameter, 'freeWord.keywords'))
      this.parameter.freeWord.operator = _.toString(_.get(parameter, 'freeWord.operator', 'and'))
      this.parameter.excludeWord.keywords = _.toArray(_.get(parameter, 'excludeWord.keywords'))
      this.parameter.workStyles.conditions = _.toArray(_.get(parameter, 'workStyles.conditions'))
      this.parameter.workStyles.operator = _.toString(_.get(parameter, 'workStyles.operator', 'and'))
      this.parameter.employmentTypes = _.toArray(_.get(parameter, 'employmentTypes'))
      this.parameter.desiredEmploymentTypes = _.toArray(_.get(parameter, 'desiredEmploymentTypes'))
      this.parameter.married = _.get(parameter, 'married', null)
      this.parameter.hasChild = _.get(parameter, 'hasChild', null)
      this.parameter.canHomeMoving = _.get(parameter, 'canHomeMoving', null)
      // 最終ログインの復元
      this.parameter.registrationDate.selectedDateTimeWithinDays = _.get(parameter, 'registrationDate.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'registrationDate.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.registrationDate, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'registrationDate.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'registrationDate.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.registrationDate, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'registrationDate.selectedDateTimeRangeForm.to')))
      }
      // レジュメ更新日の復元
      this.parameter.resumeUpdateDate.selectedDateTimeWithinDays = _.get(parameter, 'resumeUpdateDate.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.resumeUpdateDate, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to')))
      }
      this.parameter.activeDate.from = _.toString(_.get(parameter, 'activeDate.from'))
      this.parameter.activeDate.to = _.toString(_.get(parameter, 'activeDate.to'))
      this.parameter.excludedApproachedScout.otherCompany.maximum = _.get(parameter, 'excludedApproachedScout.otherCompany.maximum', null)
      this.parameter.excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays = _.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.thisJob, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to')))
      }
      this.parameter.excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays = _.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeWithinDays', null)
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm.from', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from')))
      }
      if (_.has(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')) {
        _.set(this.parameter.excludedApproachedScout.ownCompany.otherJob, 'selectedDateTimeRangeForm.to', _.toString(_.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to')))
      }
      this.parameter.excludedCandidateOtherJob = !!_.get(parameter, 'excludedCandidateOtherJob')
      this.parameter.excludeEntryOtherCompanyJob = !!_.get(parameter, 'excludeEntryOtherCompanyJob')
      this.parameter.userId = _.get(parameter, 'userId', null)

      const condition = searchData.condition
      if (condition) {
        this.condition.graduatedSchoolKeyword = _.toString(_.get(condition, 'graduatedSchoolKeyword'))
        this.condition.freeWord = _.toString(_.get(condition, 'freeWord'))
        this.condition.excludeWord = _.toString(_.get(condition, 'excludeWord'))
        this.condition.selectedRegistrationDateValue = _.defaultTo(_.get(condition, 'selectedRegistrationDateValue'), {})
        this.condition.registrationDate_from = _.toString(_.get(condition, 'registrationDate_from'))
        this.condition.registrationDate_to = _.toString(_.get(condition, 'registrationDate_to'))
        this.condition.selectedResumeUpdateDateValue = _.defaultTo(_.get(condition, 'selectedResumeUpdateDateValue'), {})
        this.condition.resumeUpdateDate_from = _.toString(_.get(condition, 'resumeUpdateDate_from'))
        this.condition.resumeUpdateDate_to = _.toString(_.get(condition, 'resumeUpdateDate_to'))
        this.condition.selectedApproachedThisJobOptionValue = _.defaultTo(_.get(condition, 'selectedApproachedThisJobOptionValue'), {})
        this.condition.approachedThisJob_from = _.get(condition, 'approachedThisJob_from', '')
        this.condition.approachedThisJob_to = _.get(condition, 'approachedThisJob_to', '')
        this.condition.selectedApproachedOtherJobOptionValue = _.defaultTo(_.get(condition, 'selectedApproachedOtherJobOptionValue'), {})
        this.condition.approachedOtherJob_from = _.get(condition, 'approachedOtherJob_from', '')
        this.condition.approachedOtherJob_to = _.get(condition, 'approachedOtherJob_to', '')
      } else {
        this.condition = createDefaultCondition(parameter)
      }
    }
  }
}

/**
 * conditionが存在しない場合にparameterの内容からデフォルト値を生成するメソッド
 * 主に旧bkoからデータ移行された検索条件に利用される
 */
function createDefaultCondition (parameter) {
  const condition = new SearchDataModel().condition
  condition.graduatedSchoolKeyword = _.toString(_.get(parameter, 'graduatedSchool.keywords', []).join(' '))
  condition.freeWord = _.toString(_.get(parameter, 'freeWord.keywords', []).join(' '))
  condition.excludeWord = _.toString(_.get(parameter, 'excludeWord.keywords', []).join(' '))
  condition.selectedRegistrationDateValue = createDateRangeOption(_.get(parameter, 'registrationDate', null), '会員登録日')
  condition.registrationDate_from = _.get(parameter, 'registrationDate.selectedDateTimeRangeForm.from', '')
  condition.registrationDate_to = _.get(parameter, 'registrationDate.selectedDateTimeRangeForm.to', '')
  condition.selectedResumeUpdateDateValue = createDateRangeOption(_.get(parameter, 'resumeUpdateDate', null), 'レジュメ更新日')
  condition.resumeUpdateDate_from = _.get(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.from', '')
  condition.resumeUpdateDate_to = _.get(parameter, 'resumeUpdateDate.selectedDateTimeRangeForm.to', '')
  condition.selectedApproachedThisJobOptionValue = createDateRangeOption(_.get(parameter, 'excludedApproachedScout.ownCompany.thisJob', null), 'スカウト送信日')
  condition.approachedThisJob_from = _.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.from', '')
  condition.approachedThisJob_to = _.get(parameter, 'excludedApproachedScout.ownCompany.thisJob.selectedDateTimeRangeForm.to', '')
  condition.selectedApproachedOtherJobOptionValue = createDateRangeOption(_.get(parameter, 'excludedApproachedScout.ownCompany.otherJob', null), 'スカウト送信日')
  condition.approachedOtherJob_from = _.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.from', '')
  condition.approachedOtherJob_to = _.get(parameter, 'excludedApproachedScout.ownCompany.otherJob.selectedDateTimeRangeForm.to', '')
  return condition
}

function createDateRangeOption (dateRangeObject, dateLabel) {
  const selectedDateTimeWithinDays = _.get(dateRangeObject, 'selectedDateTimeWithinDays', null)
  if (selectedDateTimeWithinDays === null && _.get(dateRangeObject, 'selectedDateTimeRangeForm', null) !== null) {
    return {
      terms: 'select',
      name: `${dateLabel}を指定`
    }
  } else if (selectedDateTimeWithinDays === 0) {
    return {
      terms: 0,
      name: `${dateLabel}が本日`
    }
  } else if (selectedDateTimeWithinDays === 7) {
    return {
      terms: 7,
      name: `${dateLabel}が1週間以内`
    }
  } else if (selectedDateTimeWithinDays === 14) {
    return {
      terms: 14,
      name: `${dateLabel}が2週間以内`
    }
  } else if (selectedDateTimeWithinDays === 30) {
    return {
      terms: 30,
      name: `${dateLabel}が30日以内`
    }
  } else if (selectedDateTimeWithinDays === 90) {
    return {
      terms: 90,
      name: `${dateLabel}が90日以内`
    }
  } else {
    return {}
  }
}

exports.createDefaultCondition = createDefaultCondition
exports.createDateRangeOption = createDateRangeOption
